type ScrollTo = (props: {
  scrollLeftPosition: number;
  smoothScroll?: boolean | undefined;
  scrollerElement: HTMLDivElement | null;
}) => void;

export const scrollTo: ScrollTo = ({
  scrollerElement,
  scrollLeftPosition,
  smoothScroll = true,
}) => {
  if (scrollerElement) {
    if (smoothScroll) {
      scrollerElement.scroll({
        top: 0,
        left: scrollLeftPosition,
        behavior: "smooth",
      });
    } else {
      /* eslint-disable no-param-reassign */
      scrollerElement.scrollLeft = scrollLeftPosition;
    }
  }
};
